import { render, staticRenderFns } from "./AppFeedback.vue?vue&type=template&id=8fcca1ca&scoped=true"
import script from "./AppFeedback.vue?vue&type=script&lang=js"
export * from "./AppFeedback.vue?vue&type=script&lang=js"
import style0 from "./AppFeedback.vue?vue&type=style&index=0&id=8fcca1ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcca1ca",
  null
  
)

export default component.exports